import { Chip, Typography } from '@material-ui/core';
import React from 'react';

const color = {
  good: { color: 'rgba(3, 152, 85, 1)', backgroundColor: 'rgba(236, 253, 243, 1)' },
  average: { color: 'rgba(220, 104, 3, 1)', backgroundColor: 'rgba(255, 250, 235, 1)' },
  poor: { color: 'rgba(217, 45, 32, 1)', backgroundColor: 'rgba(254, 243, 242, 1)' },
};

const ErTableColumns = [
  {
    accessorKey: 'id',
    header: 'ID',
    minSize: 50,
    maxSize: 100,
    size: 50,
    Cell: ({ cell }) => <Typography noWrap>{cell.getValue()}</Typography>,
  },
  {
    accessorKey: 'status',
    header: 'Status',
    minSize: 100,
    maxSize: 110,
    size: 100,
    Cell: ({ cell }) => (
      <Chip
        style={{
          borderRadius: '4px',
          padding: '2px, 6px, 2px, 6px',
          textTransform: 'capitalize',
          ...(color[cell.getValue()] || {}),
        }}
        label={cell.getValue()}
      />
    ),
  },
  {
    accessorKey: 'name',
    header: 'Dealership Name',
    minSize: 170,
    maxSize: 500,
    size: 170,
    Cell: ({ cell }) => <Typography noWrap>{cell.getValue()}</Typography>,
  },
  {
    accessorKey: 'pxOwnerName',
    header: 'PX Owner',
    minSize: 140,
    maxSize: 500,
    size: 140,
    Cell: ({ cell }) => <Typography noWrap>{cell.getValue()}</Typography>,
  },
  {
    accessorKey: 'parent',
    header: 'Group Name',
    minSize: 170,
    maxSize: 500,
    size: 170,
    Cell: ({ cell }) => <Typography noWrap>{cell.getValue()}</Typography>,
  },
  {
    accessorKey: 'totalUsers',
    header: 'Total Users',
    minSize: 110,
    maxSize: 110,
    size: 110,
  },
  {
    accessorKey: 'activeUsers',
    header: 'MAU',
    minSize: 65,
    maxSize: 65,
    size: 65,
  },
  {
    accessorKey: 'dailyActiveUsers',
    header: 'DAU',
    minSize: 62,
    maxSize: 62,
    size: 62,
  },
  {
    accessorKey: 'mauPercent',
    header: 'MAU%',
    minSize: 78,
    maxSize: 78,
    size: 78,
  },
  {
    accessorKey: 'dauPercent',
    header: 'DAU%',
    minSize: 78,
    maxSize: 78,
    size: 78,
  },
  {
    accessorFn: (originalRow) => originalRow.scores.metrics.find((i) => i.type === 'management').value,
    header: 'Management Score',
    minSize: 170,
    maxSize: 170,
    size: 170,
  },
  {
    accessorFn: (originalRow) => originalRow.scores.metrics.find((i) => i.type === 'consistency').value,
    header: 'Consistency Score',
    minSize: 170,
    maxSize: 170,
    size: 170,
  },
  {
    accessorFn: (originalRow) => originalRow.scores.metrics.find((i) => i.type === 'activity').value,
    header: 'Activity Score',
    minSize: 130,
    maxSize: 130,
    size: 130,
  },
  {
    accessorFn: (originalRow) => originalRow.scores.value,
    header: 'Total Score',
    minSize: 120,
    maxSize: 120,
    size: 120,
  },
  {
    accessorKey: 'learningUnits',
    header: 'LU Completed',
    minSize: 150,
    maxSize: 150,
    size: 150,
  },
  {
    accessorKey: 'totalGuideCount',
    header: 'Guides Completed',
    minSize: 165,
    maxSize: 165,
    size: 165,
  },
  {
    accessorKey: 'totalDoseCount',
    header: 'Daily Completed',
    minSize: 165,
    maxSize: 165,
    size: 165,
  },
  {
    accessorKey: 'totalCapstoneCount',
    header: 'Capstone Completed',
    minSize: 180,
    maxSize: 180,
    size: 180,
  },
  {
    accessorKey: 'totalGuideShared',
    header: 'Guides Shared',
    minSize: 140,
    maxSize: 140,
    size: 140,
  },
  {
    accessorKey: 'leadPipelineStatus',
    header: 'Sales Pipeline Status',
    minSize: 200,
    maxSize: 200,
    size: 200,
    Cell: ({ cell }) => <Typography noWrap>{cell.getValue()}</Typography>,
  },
  {
    accessorKey: 'enabled',
    header: 'Enabled',
    minSize: 90,
    maxSize: 90,
    size: 90,
    Cell: ({ cell }) => <Typography noWrap> {String(cell.getValue())} </Typography>,
  },
  {
    accessorKey: 'source',
    header: 'Source',
    minSize: 134,
    maxSize: 134,
    size: 134,
    Cell: ({ cell }) => <Typography noWrap>{cell.getValue()}</Typography>,
  },
  {
    accessorKey: 'chargifyId',
    header: 'Chargify Id',
    minSize: 134,
    maxSize: 250,
    size: 134,
    Cell: ({ cell }) => <Typography noWrap>{cell.getValue()}</Typography>,
  },
  {
    accessorKey: 'domains',
    header: 'Domains',
    minSize: 300,
    maxSize: 500,
    size: 300,
    Cell: ({ cell }) => <Typography noWrap> {cell.getValue()?.join(', ')} </Typography>,
  },
];

export default ErTableColumns;
